import React from 'react';

import { useTranslation } from 'react-i18next';

import processing_activities_messages from 'messages/processing_activities_messages';

import useStyles from '../../ProcessingActivitiesAssetReviewsPage/ProcessingActivitiesAssetReviewsPage.styles';

import { formatRetentionPeriodAndUnit } from './apaRetention.helpers';

export const APA_EMPTY_VALUE = '—';
export const APA_MULTILINE_MAX_ROWS = 12;

type ApaReadFieldProps = {
  label: string;
  preserveLineBreaks?: boolean;
  value?: React.ReactNode;
};

export const ApaReadField: React.FC<ApaReadFieldProps> = ({ label, preserveLineBreaks = true, value }) => {
  const styles = useStyles();
  const isEmpty = value == null || value === '';
  const content = isEmpty ? APA_EMPTY_VALUE : value;

  return (
    <div>
      <div className={styles.fieldLabel}>{label}</div>
      {typeof content === 'string' || typeof content === 'number' ? (
        <div className={preserveLineBreaks ? styles.preLineValue : undefined}>{content}</div>
      ) : (
        <div>{content}</div>
      )}
    </div>
  );
};

type ApaRetentionReadFieldsProps = {
  commentLabel?: string;
  deletionLabel?: string;
  deletionRoutine?: string;
  periodAndUnitLabel?: string;
  retentionComment: string;
  retentionTrigger: string;
  retentionUnit: string;
  retentionValue: number | null;
  showDeletionRoutine?: boolean;
  triggerLabel?: string;
};

export const ApaRetentionReadFields: React.FC<ApaRetentionReadFieldsProps> = ({
  commentLabel,
  deletionLabel,
  deletionRoutine,
  periodAndUnitLabel,
  retentionComment,
  retentionTrigger,
  retentionUnit,
  retentionValue,
  showDeletionRoutine = false,
  triggerLabel,
}) => {
  const { t } = useTranslation();
  const messages = processing_activities_messages.asset_ropa.apa_editor.sections.purposes;

  return (
    <>
      <ApaReadField label={triggerLabel ?? t(messages.retention_trigger)} value={retentionTrigger} />
      <ApaReadField
        label={periodAndUnitLabel ?? t(messages.retention_period_and_unit)}
        preserveLineBreaks={false}
        value={formatRetentionPeriodAndUnit(retentionValue, retentionUnit, t)}
      />
      <ApaReadField label={commentLabel ?? t(messages.retention_comment)} value={retentionComment} />
      {showDeletionRoutine && <ApaReadField label={deletionLabel ?? t(messages.deletion_routine)} value={deletionRoutine} />}
    </>
  );
};
